import { render, staticRenderFns } from "./Organize.vue?vue&type=template&id=3724e531&scoped=true&"
import script from "./Organize.vue?vue&type=script&lang=js&"
export * from "./Organize.vue?vue&type=script&lang=js&"
import style0 from "./Organize.vue?vue&type=style&index=0&id=3724e531&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724e531",
  null
  
)

export default component.exports